import { useState } from 'react';

export function ContactForm() {
  const [form, setForm] = useState({
    name: '',
    subject: '',
    email: '',
    phone: '',
    message: '',
  });
  const [state, setState] = useState<'idle' | 'sending' | 'ok' | 'error'>('idle');

  const set = <K extends keyof typeof form>(k: K, v: string) =>
    setForm((f) => ({ ...f, [k]: v }));

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setState('sending');
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/public/contact`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        setState('error');
        return;
      }
      setState('ok');
      setForm({ name: '', subject: '', email: '', phone: '', message: '' });
    } catch {
      setState('error');
    }
  }

  return (
    <form onSubmit={onSubmit} className="ts-contact-form" noValidate>
      <h3 className="title">
        لنتعاون معاً!
        <br />
        املأ النموذج أدناه.
      </h3>

      <div className="row">
        <div className="col-half">
          <div className="ts-input-box">
            <input
              type="text"
              placeholder="الاسم الكامل"
              value={form.name}
              onChange={(e) => set('name', e.target.value)}
              required
            />
          </div>
        </div>
        <div className="col-half">
          <div className="ts-input-box">
            <input
              type="text"
              placeholder="الموضوع"
              value={form.subject}
              onChange={(e) => set('subject', e.target.value)}
              required
            />
          </div>
        </div>
        <div className="col-half">
          <div className="ts-input-box">
            <input
              type="email"
              placeholder="البريد الإلكتروني"
              value={form.email}
              onChange={(e) => set('email', e.target.value)}
              required
            />
          </div>
        </div>
        <div className="col-half">
          <div className="ts-input-box">
            <input
              type="tel"
              placeholder="رقم الهاتف"
              value={form.phone}
              onChange={(e) => set('phone', e.target.value)}
            />
          </div>
        </div>
        <div className="col-full">
          <div className="ts-input-box">
            <textarea
              placeholder="أخبرنا عن رسالتك…"
              value={form.message}
              onChange={(e) => set('message', e.target.value)}
              required
            />
          </div>
        </div>
        <div className="col-full">
          <button type="submit" className="ts-main-btn" disabled={state === 'sending'}>
            {state === 'sending' ? 'جاري الإرسال...' : 'إرسال الرسالة'}
          </button>
          {state === 'ok' && (
            <p className="ts-form-status ok">شكراً، تم استلام رسالتكم.</p>
          )}
          {state === 'error' && (
            <p className="ts-form-status err">فشل الإرسال — حاولوا لاحقاً.</p>
          )}
        </div>
      </div>
    </form>
  );
}
